// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"73":"089ac534527dc8da","342":"fbe2a1a103f685d0","409":"388485f8e342d780","679":"38be242daa11ad5e","960":"fa13136aa6326623"}[chunkId] + ".js";
};